import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;
import { AuthService } from '../services/auth-service';
import { cachedFetch } from '../utils/cachedFetch.js';
import { deleteAllCache  } from '../utils/cache';


@customElement('modal-component')
export class ModalComponent extends LitElement {
  @property({ type: Boolean }) open = false;
  @property({ type: Array }) workers = [];
  @property({ type: Array }) myShiftWorkers = [];
  @property({ type: Boolean }) shiftModalOpen = false;
  @property({ type: String }) activeSection: string | null = '';
  @property({ type: String }) selectedShift: string = '';
  @property({ type: String }) selectedColor: string = '';
  @property({ type: Boolean }) isSpecialNight = false;
  @property({ type: String }) selectedDate: string = '';
  @property({ type: Boolean }) teamScheduleGenerated = false;
  @property({ type: Boolean }) ModifiedByUser = false;

  private workerId: string | null = localStorage.getItem('workerNumber');
  private workersByShift: Record<string, any[]> = {};
@state() private activeSubsection: string = '';


static styles = css`
  /* Light Mode */
  @media (prefers-color-scheme: light) {
    :host {
      --background-color: #f3f3f3;
      --text-color: #333333;
      --header-background: #003366;
      --header-text: white;
      --calendar-background: #ffffff;
      --box-shadow-color: rgba(0, 0, 0, 0.1);
      --button-background: #003366;
      --button-text: #ffffff;
      --button-hover: #00509e;
      --day-name-color: #003366;
      --day-background: #f0f0f0;
      --today-background: #003366;
      --today-text: #ffffff;
      --footer-color: #aaa;
      --footer-link-color: #00509e;
    }
  }

  /* Dark Mode */
  @media (prefers-color-scheme: dark) {
    :host {
      --background-color: #181818;
      --text-color: #e0e0e0;
      --header-background: #1e1e1e;
      --header-text: #ffffff;
      --calendar-background: #1e1e1e;
      --box-shadow-color: rgba(255, 255, 255, 0.1);
      --button-background: #333333;
      --button-text: #ffffff;
      --button-hover: #555555;
      --day-name-color: #aaaaaa;
      --day-background: #2c2c2c;
      --today-background: #00509e;
      --today-text: #ffffff;
      --footer-color: #888888;
      --footer-link-color: #4a90e2;
    }
  }

  /* Modal Base Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }

  .modal-overlay.open {
    opacity: 1;
    pointer-events: all;
  }

  .modal {
    background-color: var(--background-color);
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    padding: 20px;
    box-shadow: 0 4px 6px var(--box-shadow-color);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .modal-content {
    flex: 1;
    padding: 10px;
    font-size: 1rem;
    color: var(--text-color);
    overflow-y: auto;
    max-height: 70vh;
  }

  .section {
    margin-bottom: 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: var(--calendar-background);
  }

  .section-header {
    font-weight: bold;
    font-size: 1.1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background-color: var(--header-background);
    color: var(--header-text);
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }

.sub-section-header {
  font-weight: bold;
  font-size: 1rem; /* Slightly smaller */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px; /* Less vertical and a bit more horizontal spacing */
  background-color: var(--header-background);
  color: var(--header-text);
  border-radius: 4px;
  transition: background-color 0.3s ease;
  line-height: 1.2; /* Avoids bloating the height */
}


  .section-header:hover {
    background-color: var(--button-hover);
  }

  .chevron {
    font-size: 1.25rem;
    transition: transform 0.3s ease;
  }

  .chevron.open {
    transform: rotate(180deg);
  }

  .worker-list {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    padding: 0;
  }

  .worker-list.open {
    max-height: 300px;
    overflow-y: auto;
    padding: 10px 15px;
  }

  .worker {
    margin-bottom: 8px;
  }

  .worker.green {
    color: green;
  }

  .worker.red {
    color: red;
  }

.worker.yellow {
  color: goldenrod;
}

  .dropdown {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 1rem;
  }

  .warning-message {
    background-color: #ffcccc;
    color: #b30000;
    font-weight: bold;
    font-size: 1.1rem;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    border: 1px solid #b30000;
  }

  .button {
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .save-button {
    background-color: var(--button-background);
    color: var(--button-text);
  }

  .save-button:hover {
    background-color: var(--button-hover);
  }

  .close-button {
    background-color: #dc3545;
    color: var(--button-text);
  }

  .close-button:hover {
    background-color: #c82333;
  }

  .special-night-checkbox {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 40px;
  font-size: 0.9rem;
  font-weight: 500;
}

.special-night-checkbox input {
  margin-right: 8px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.special-night-checkbox label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

`;


 toggleSubsection(shift: string) {
    // Toggle the active state for the given shift
    if (this.activeSubsection === shift) {
      this.activeSubsection = ''; // Close the subsection if it's already active
    } else {
      this.activeSubsection = shift; // Open the subsection for the selected shift
    }
  }

  // Fetch workers grouped by shift from the new endpoint
private async fetchWorkers(day: string, month: string, year: string) {
  try {
    const response = await cachedFetch(`${apiServerUrl}/all-day-shift?day=${day}&month=${month}&year=${year}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${AuthService.getToken()}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      const grouped = this.groupWorkersByShift(data.shiftWorkers || []);
      this.workersByShift = grouped;
    } else {
      console.error('Error fetching workers by shift:', await response.text());
    }
  } catch (error) {
    console.error('Error fetching workers by shift:', error);
  }
}


private groupWorkersByShift(workers: any[]) {
  const grouped: Record<string, any[]> = {
    S: [],
    D: [],
    N: [],
  };

  workers.forEach(worker => {
    const shift = worker.shift;

    if (shift === 'S' || shift === 'D' || shift === 'N') {
      grouped[shift].push(worker);
    } else if (shift === 'T') {
      grouped['S'].push(worker); // Merge T into S
    }
  });

  return grouped;
}




  // Call this method when the component is first rendered
connectedCallback() {
  super.connectedCallback();

  // Extract the date in the format "YYYY-MM-DD"
  const selectedDateFormatted = this.selectedDate.split('T')[0];

  // Call fetchWorkers with the formatted date
  const [year, month, day] = selectedDateFormatted.split('-');
  this.fetchWorkers(day, month, year);
}


private async resetShiftChange() {
  const workerNumber = this.workerId;
  const date = this.selectedDate.split('T')[0];

  if (!workerNumber || !date) {
    console.warn('Missing worker number or date for shift reset');
    return;
  }

  try {
      const res = await fetch(`${apiServerUrl}/user-schedule`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AuthService.getToken()}` // or however you store your token
      },
      body: JSON.stringify({ workerNumber, date })
    });

    const result = await res.json();

    if (!res.ok) {
      console.error('Failed to reset shift:', result.message);
      alert(result.message || 'Failed to reset shift');
      return;
    }
        deleteAllCache();
        this.closeShiftModal();
        this.dispatchEvent(new CustomEvent('refresh-calendar', {
          detail: { message: 'Refresh the calendar' },
          bubbles: true,
          composed: true,
        }));

    alert('Shift reset successfully');
  } catch (error) {
    console.error('Error resetting shift:', error);
    alert('Unexpected error occurred while resetting shift');
  }
}


  private async saveShiftChange() {
    try {
      const shiftChangeData = {
        workerNumber: this.workerId,
        date: this.selectedDate.split('T')[0],
        shift: this.selectedShift,
        color: this.selectedColor,
        isSpecial: this.isSpecialNight,
      };

      const response = await fetch(`${apiServerUrl}/update-schedule`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${AuthService.getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(shiftChangeData),
      });

      const data = await response.json();

      if (response.ok) {
        alert('Shift change updated successfully!');
        deleteAllCache();
        this.closeShiftModal();
        this.dispatchEvent(new CustomEvent('refresh-calendar', {
          detail: { message: 'Refresh the calendar' },
          bubbles: true,
          composed: true,
        }));
      } else {
        console.error('Error updating shift change:', data);
      }
    } catch (error) {
      console.error('Error sending shift change request:', error);
    }
  }

  private toggleSection(section: string) {
    this.activeSection = this.activeSection === section ? null : section;
  }

  private close() {
    this.open = false;
    this.dispatchEvent(new CustomEvent('close'));
  }

  private openShiftModal() {
    this.shiftModalOpen = true;
  }

  private closeShiftModal() {
    this.shiftModalOpen = false;
  }

private renderWorker(worker: any) {
  let classes = 'worker';

  // Normalize the name: prefer `name`, fallback to `workerName`
  let displayName = worker.name || worker.workerName || 'Unknown';

  if (worker.shift === 'T') {
    classes += ' green';
    displayName += ' (T)';
  }

  if (worker.color === 'BHT') {
    classes += ' red';
    displayName += ` (${worker.color})`;
  }
  if (worker.color === 'EXT') {
    classes += ' yellow';
    displayName += ` (${worker.color})`;
  }

  return html`<div class="${classes}">${displayName}</div>`;
}


  private handleShiftChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedShift = selectElement.value;
  }

  private handleWorkCategoryChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedColor = selectElement.value;
  }

  private handleSpecialNightToggle(event: Event) {
    this.isSpecialNight = (event.target as HTMLInputElement).checked;
  }

render() {
  return html`
    <div class="modal-overlay ${this.open ? 'open' : ''}" @click=${this.close}>
      <div class="modal" @click=${(e: Event) => e.stopPropagation()}>
        <div class="modal-content">

          <!-- Available Workers Section -->
          <div class="section">
            <div class="section-header" @click=${() => this.toggleSection('available')}>
              Available Workers
              <span class="chevron ${this.activeSection === 'available' ? 'open' : ''}">▼</span>
            </div>
            <div class="worker-list ${this.activeSection === 'available' ? 'open' : ''}">
              ${this.workers.map(worker => this.renderWorker(worker))}
            </div>
          </div>

          <!-- Your Shift Workers Section -->
          <div class="section">
            <div class="section-header" @click=${() => this.toggleSection('shift')}>
              Your Shift Workers
              <span class="chevron ${this.activeSection === 'shift' ? 'open' : ''}">▼</span>
            </div>
            <div class="worker-list ${this.activeSection === 'shift' ? 'open' : ''}">
              ${this.myShiftWorkers.map(worker => this.renderWorker(worker))}
            </div>
          </div>

          <!-- All Workers by Shift Section -->
<!-- All-Day Workers by Shift Section -->
<div class="section">
  <div class="section-header" @click=${() => this.toggleSection('all-day')}>
    All-Day Shift Workers
    <span class="chevron ${this.activeSection === 'all-day' ? 'open' : ''}">▼</span>
  </div>
  <div class="worker-list ${this.activeSection === 'all-day' ? 'open' : ''}">
    ${['S', 'D', 'N'].map(shift => html`
      <div>
        <div class="sub-section-header" style="margin-top: 10px;" @click=${() => this.toggleSubsection(shift)}>
          ${shift}
          <span class="chevron ${this.activeSubsection === shift ? 'open' : ''}">▼</span>
        </div>
        <div class="worker-list ${this.activeSubsection === shift ? 'open' : ''}">
          ${(this.workersByShift[shift] || []).map(worker => this.renderWorker(worker))}
        </div>
      </div>
    `)}
  </div>
</div>




        </div>

        <div class="modal-footer">
          <button class="button" @click=${this.openShiftModal} ?hidden=${this.teamScheduleGenerated}>
            Change Shift
          </button>
        </div>
      </div>
    </div>

    ${this.shiftModalOpen ? html`
      <div class="modal-overlay open" @click=${this.closeShiftModal}>
        <div class="modal" @click=${(e: Event) => e.stopPropagation()}>
          <div class="modal-content">
            <h2>Change Your Shift</h2>
            <p class="warning-message">
              ⚠️ Attention! User-changed shifts will no longer be updated automatically.
            </p>

            <label for="shift-type">Select Shift Type:</label>
            <select id="shift-type" class="dropdown" .value="${this.selectedShift}" @change=${this.handleShiftChange}>
              <option value="S">S</option>
              <option value="T">T</option>
              <option value="D">D</option>
              <option value="N">N</option>
              <option value="DC">DC</option>
              <option value="DS">DS</option>
              <option value="HR-35">HR-35</option>
            </select>

            ${this.selectedShift === "S" || this.selectedShift === "D" ? html`
              <div class="special-night-checkbox">
                <label>
                  <input type="checkbox" .checked=${this.isSpecialNight} @change=${this.handleSpecialNightToggle} />
                  Flexible night shift?
                </label>
              </div>
            ` : ''}

            <label for="work-category">Select Work Category:</label>
            <select id="work-category" class="dropdown" .value="${this.selectedColor}" @change=${this.handleWorkCategoryChange}>
              <option value="N/A">Normal</option>
              <option value="BHT">BHT</option>
              <option value="EXT">Extra</option>
            </select>
          </div>

          <div class="modal-footer">
            <button class="button save-button" @click=${this.saveShiftChange}>Save</button>
            ${this.ModifiedByUser ? html`<button class="button save-button" @click=${this.resetShiftChange}>Reset Shift</button>` : console.log(this.ModifiedByUser)}
            <button class="button close-button" @click=${this.closeShiftModal}>Close</button>
          </div>
        </div>
      </div>
    ` : ''}

  `;
}


}
